import { getJWT } from '@bynder/js-access-token-lib';

export async function getAppCodes() {
	const jwt = await getJWT();
	const jwtDecoded = decodeJWT(jwt);

	return jwtDecoded.app_codes;
}

export async function getModulePermissions(): Promise<string[]> {
	const jwt = await getJWT();
	const jwtDecoded = decodeJWT(jwt);

	return jwtDecoded.module_permissions;
}

function decodeJWT(token: string) {
	const base64Url = token.split('.')[1];
	const base64 = base64Url.replaceAll(/-/g, '+').replaceAll(/_/g, '/');
	const jsonPayload = decodeURIComponent(
		window
			.atob(base64)
			.split('')
			.map(function f(c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			})
			.join(''),
	);

	return JSON.parse(jsonPayload);
}
